// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__qsV7Q","truncatedText":"styles_truncatedText__6j8Ba","fullText":"styles_fullText__9zO5s","textContainer":"styles_textContainer__CaO5E"};